<template>
  <button
    :title="label"
    class="naked w-twentyTwo sm:w-twentyFive text-midGray hover:text-black focus:text-black active:text-midGray disabled:text-hoverGray cursor-pointer disabled:cursor-not-allowed"
    @click="$emit('maximised')"
  >
    <MaximiseControlIcon aria-hidden="true" />
  </button>
</template>

<script>
import { defineComponent } from 'vue';

import i18n from '@/locales';

import { MaximiseControlIcon } from '@/components/icons';

export default defineComponent({
  name: 'MaximiseControl',
  components: {
    MaximiseControlIcon,
  },
  props: {
    label: {
      type: String,
      required: false,
      default() {
        return i18n.t('ui.common.cardControls.maximise');
      },
    },
  },
});
</script>
